import { DeLang, EnLang } from 'src/svg/Languages';
import { Language } from './types';

export const SUPPORTED_LANGUAGES = {
  en: 'en',
  de: 'de'
  // pl: 'pl',
  // ro: 'ro'
};

export type SupportedLanguages = keyof typeof SUPPORTED_LANGUAGES;

export const languageOptions: Record<SupportedLanguages, Language> = {
  en: {
    icon: EnLang,
    labelName: 'English',
    currency: 'EUR',
    code: 'en',
    title: 'en'
  },
  de: {
    icon: DeLang,
    labelName: 'Deutsch',
    currency: 'EUR',
    code: 'de-DE',
    title: 'de'
  }
  // pl: {
  //   icon: PlLang,
  //   labelName: 'Polish',
  //   currency: 'EUR',
  //   code: 'pl',
  //   title: 'pl'
  // },
  // ro: {
  //   icon: RoLang,
  //   labelName: 'Romanian',
  //   currency: 'EUR',
  //   code: 'ro',
  //   title: 'ro'
  // }
};
export const COUNTRY_TO_LANG: Record<string, SupportedLanguages> = {
  DEU: 'de'
  // POL: 'pl',
  // ROU: 'ro'
};

export const arrayLanguagesOptions = Object.values(languageOptions);

export const LS_LANGUAGE_KEY = 'language';
export const LS_DEBUG_LANGUAGE_KEY = 'debug_language';
